export const selectAgent = (state: ReduxState) => state.agent;
export const selectAgentProducerExternalId = (state: ReduxState) => selectAgent(state)?.producerExternalID;
export const selectAgentProducerName = (state: ReduxState) => selectAgent(state)?.producerName;
export const selectAgentAgencyName = (state: ReduxState) => selectAgent(state)?.agencyName;
export const selectIsAgentMDA = (state: ReduxState) => selectAgent(state)?.isMDA;
export const selectMDALeadEmailSent = (state: ReduxState) => selectAgent(state)?.mdaLeadEmailSent ?? false;
export const selectAgentAgencyExternalId = (state: ReduxState) => selectAgent(state)?.agencyExternalId;
